import * as THREE from 'three';
import {Vector2, Vector3} from "three";
import store from "../store";
import {getPerspectivePoints} from "../fabric/libs/getPerspectivePoints";
import {getPerspectiveMatrix} from "../math/perspectiveTransform";
import {translatePoints} from "../math/getAreaCorrected";


export const findPlanePerspective = async function(planeID, camera, photoID) {
    this.starttime = new Date().getTime();
    this.camera = camera;
    this.imageSize = await store.dispatch("active/GET_ACTIVE_IMG_SIZE");
    this.width = this.imageSize.width;
    this.height = this.imageSize.height;
    this.points = getPerspectivePoints(planeID, photoID);
    this.lineLenght = [];
    for (let i = 0; i<this.points.length-1; i++) {
        let point1 = new Vector2(this.points[i].x, this.points[i].y);
        let point2 = new Vector2(this.points[i+1].x, this.points[i+1].y);
        this.lineLenght.push(point1.distanceTo(point2));
    }
    let point1 = new Vector2(this.points[0].x, this.points[0].y);
    let point2 = new Vector2(this.points[3].x, this.points[3].y);
    this.lineLenght.push(point1.distanceTo(point2));

    const activeProjectGUID = store.state.route.params.projectUUID;
    // const photoID = store.state.route.params.photoID
    // let perspectiveMatrix = store.getters[`projectList/${activeProjectGUID}/photoList/${photoID}/planeList/${planeID}/PERSPECTIVE_MATRIX`];
    // if (!perspectiveMatrix) {
    //     perspectiveMatrix = await getPerspectiveMatrix({
    //         planeID: planeID,
    //         photoID: photoID,
    //         scale: 1 / window.devicePixelRatio
    //     })
    // }
    let perspectiveMatrix = await store.dispatch(
        `projectList/${activeProjectGUID}/photoList/${photoID}/planeList/${planeID}/GET_PERSPECTIVE_MATRIX`,
        {planeID, photoID});

    this.flatPoints = translatePoints(perspectiveMatrix, this.points);

    this.center = new Vector3(
        this.flatPoints[0].x + (this.flatPoints[1].x - this.flatPoints[0].x) / 2,
        this.width-(this.flatPoints[1].y + (this.flatPoints[2].y - this.flatPoints[1].y) / 2),
        0)


    let matrix = new THREE.Matrix4();
    let needRotateFactor = Math.abs(1 - this.lineLenght[1]/this.lineLenght[3]);
    if (needRotateFactor > 0.1)
        if (this.lineLenght[1] > this.lineLenght[3])
            matrix.makeRotationY( Math.PI/4 );
        else
            matrix.makeRotationY(-Math.PI/4);
    this.camera.position.applyMatrix4(matrix);

    this.camera.userData.target = new Vector3(this.width/2, this.height/2, 0)
    this.camera.lookAt(this.camera.userData.target);

    this.camera.updateProjectionMatrix();
    this.camera.updateMatrixWorld();

    this.get_dom_position = (point) => {
        let world_position = point.clone();
        let projection_position = world_position.project(this.camera);
        let dom_position = new Vector2(
            (projection_position.x * this.width/2) + this.width/2,
            (projection_position.y * this.height/2) + this.height/2
        );
        return dom_position
    };

    this.compute = (params) => {
        let quadratic_mean = this.compute_quadratic_mean();
        let error = 0.1;
        let last_quadratic_mean;
        let first_quadratic_mean = quadratic_mean;
        let step = 0.1;
        for (let i = 0; i <= 30000; i++) {
            last_quadratic_mean = quadratic_mean;
            // step*=0.9999;
            // stepMult = 1/(Math.pow(i+1,0.2));
            // console.log(step)
            this.parameter_variation(this.camera.position, "x", step);
            this.parameter_variation(this.camera.position, "y", step);
            this.parameter_variation(this.camera.position, "z", step);
            this.parameter_variation(this.camera.userData.target, "x", step);
            this.parameter_variation(this.camera.userData.target, "y", step);
            this.parameter_variation(this.camera.userData.target, "z", step);
            this.parameter_variation(this.camera.up, "x", 0.01);
            this.parameter_variation(this.camera.up, "y", 0.01);
            this.parameter_variation(this.camera.up, "z", 0.01);
            this.parameter_variation(this.camera, "fov", 0.01);

            quadratic_mean = this.compute_quadratic_mean();

            if (quadratic_mean >= last_quadratic_mean - error) {
                console.log("iterations: ",i);
                console.log("time MS: ",new Date().getTime()-this.starttime);
                console.log("camera fov: ",this.camera.fov);
                console.log("quadratic_mean: ",quadratic_mean);
                return (1 - Math.sqrt(quadratic_mean) / Math.sqrt(first_quadratic_mean)) * 100;
            }

        }
    };

    this.parameter_variation = (object, parameter, step) => {
        let direction = 1;
        let ch_direction = false;
        let quadratic_mean = this.compute_quadratic_mean();
        let last_quadratic_mean;
        for (let i = 0; i <= 10; i++) {
            if (typeof (object[parameter]) === "function")
                object[parameter](step * direction)
            else
                object[parameter] += step * direction;
            last_quadratic_mean = quadratic_mean;
            quadratic_mean = this.compute_quadratic_mean();
            if (last_quadratic_mean <= quadratic_mean) {
                if (ch_direction) {
                    if (typeof (object[parameter]) === "object")
                        object[parameter](step * direction)
                    else
                        object[parameter] -= step * direction;

                    break;
                }
                direction *= -1;
                ch_direction = true;
            }
        }
    };

    this.compute_quadratic_mean = () => {
        this.camera.lookAt(this.camera.userData.target);
        this.camera.updateProjectionMatrix();
        this.camera.updateMatrixWorld();
        this.cameraProjectionPoints = [];
        this.scenePoints.forEach((point)=>{
            this.cameraProjectionPoints.push(this.get_dom_position(point.position));
        })

        let quadratic_mean = 0;

        for (let index in this.points)
        {
            quadratic_mean += Math.pow(this.cameraProjectionPoints[index].distanceTo(this.yUpPoints[index]),2);
        }
        return quadratic_mean;
    };


    this.scenePoints = [];
    this.flatPoints.forEach((point)=>{
        let sphere = new THREE.SphereGeometry(10, 10, 10);
        let material = new THREE.MeshBasicMaterial({color: 0x00FFFF});
        let scenePoint = new THREE.Mesh(sphere, material)
        scenePoint.position.set(point.x, this.width - point.y,0);
        this.scenePoints.push(scenePoint);
        // this.scene.add(scenePoint);
    })
    this.cameraProjectionPoints = [];
    this.scenePoints.forEach((point)=>{
        this.cameraProjectionPoints.push(this.get_dom_position(point.position));
    })

    this.yUpPoints = [];
    this.points.forEach((point)=>{
        this.yUpPoints.push(new Vector2(point.x,this.height - point.y));
    })


    return this.compute();
}

